export default __webpack_public_path__ + "static/media/people4.13ab950b.png";